/* eslint-disable max-lines */
/* eslint-disable sort-keys */
/* eslint-disable max-len */
import {
  NAME_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  PASSWORD_MAX_LENGTH,
  UNIVERSITY_MIN_LENGTH,
  NAME_MIN_LENGTH,
} from '../../constants/validator'

export const RU = {
  app: {
    confirmEmail: {
      title: 'Не удалось подтвердить адрес электронной почты',
      description: 'Вы уже ранее подтвердили свою электронную почту, или что-то пошло не так',
      description2:
        'Попробуйте еще раз перейти по ссылке подтверждения позднее или обратитесь в нашу службу поддержки по телефону',
      phone: '8 (495) 775-77-65',
    },
    updateEmail: {
      success: {
        title: 'Адрес электронной почты успешно обновлен',
      },
      error: {
        title: 'Не удалось обновить адрес электронной почты',
        description:
          'Попробуйте еще раз перейти по ссылке подтверждения позднее или обратитесь в нашу службу поддержки по телефону',
        phone: '8 (495) 775-77-65',
      },
    },
    errors: {
      'A previous email sent less than a minute ago':
        'Письмо было отправлено менее минуты назад, пожалуйста, подождите',
      'The previous active code was generated less than a minute ago':
        'Код был сгенерирован менее минуты назад, пожалуйста, подождите',
      'A previous sms code sent less than a minute ago':
        'Код был сгенерирован менее минуты назад, пожалуйста, подождите',
      'A previous call less than a minute ago': 'Код был сгенерирован менее минуты назад, пожалуйста, подождите',
      'Invalid verification sms code entered': 'Введен неверный проверочный sms-код',
      'Invalid verification call code entered': 'Вы ввели неверный код',
      'Try after 30 seconds': 'Повторите попытку через 30 секунд',
      'Try after 1 hour': 'Исчерпан лимит запросов, повторите попытку через 1 час',
      invalidDate: {
        message: 'Дата имеет неверное значение',
      },
      passwordError: {
        necessarilyUse: 'Обязательно используйте:',
        minAndMaxLength: `от ${PASSWORD_MIN_LENGTH} символов до ${PASSWORD_MAX_LENGTH}`,
        withoutSpaces: 'без пробелов',
        withUpperCase: 'одну заглавную букву',
        withLowerCase: 'одну строчную букву',
        and: 'и',
        and2: 'и',
        may: 'Можно',
        useLatinLetter: 'латинские буквы',
        letters: 'цифры',
        withNumber: 'одну цифру',
        signs: 'знаки .@-',
      },
    },
    footer: {
      contacts: {
        digital: {
          title: 'Электронные издания',
        },
        periodic: {
          title: 'Печатные издания',
        },
      },
      copyright: 'Группа компаний Актион',
      copyrightUZ: 'ООО «Издательский дом МЦФЭР-У»',
    },
    logon: {
      authorization: {
        buttonText: 'Войти',
        updatePassword: 'Обновить пароль',
        concatenationText: 'или',
        continue: 'Продолжить',
      },
      companyDescription: 'Группа и сеть профессиональных сайтов',
      login: {
        errors: {
          incorrectEmailOrPhone: {
            message: 'Неверный формат почты или телефона',
          },
          valueIsRequired: {
            message: 'Введите эл. почту или телефон',
          },
          serverError: {
            message: 'Ошибка сервера. Пока авторизоваться не получится. Попробуйте еще раз через несколько минут',
          },
        },
        label: 'Почта или телефон',
        loginWith: 'Войти с помощью',
        resend: 'Отправить повторно',
        smsText: 'Отправить СМС',
        callText: 'Позвонить повторно',
        confirmEmail: 'Почта не подтверждена. Перейдите по ссылке из письма, чтобы завершить регистрацию',
      },
      password: {
        errors: {
          valueIsRequired: {
            message: 'Введите пароль',
          },
          wrongPassword: 'Неверный логин или пароль.',
          wrongPasswordForEmail: ' ',
          oldPassword: 'Ваш пароль устарел. Обновите.',
          samePassword: 'Новый пароль должен отличаться от старого',
          oldPage: 'Страница устарела. Вернитесь на форму авторизации',
        },
        label: 'Пароль',
        reset: {
          successText: 'Письмо отправлено, проверьте почту',
          successPhoneText: 'Код отправлен вам в смс',
          forgotPassword: 'Не помню пароль',
        },
        updatePassword: 'Обновить пароль',
      },
      phoneCode: {
        errors: {
          incorrectValue: {
            message: 'Введен неверный код из смс',
          },
          valueIsRequired: {
            message: 'Введите код из СМС',
          },
          callCodeLength: {
            message: 'Введите последние 4 цифры входящего номера',
          },
          smsCodeLength: {
            message: 'Введите код из 5 символов',
          },
        },
        label: 'Код из смс',
        enterCallCodeText: 'Введите последние 4 цифры входящего номера',
      },
      registration: {
        createAccount: 'Создать аккаунт',
      },
      paywall: {
        downloadFileAfterRegistration: 'Скачать файл после регистрации',
      },
      title: 'Вход в продукты',
    },
    changePassword: {
      title: 'Смена пароля',
      submitButton: 'Сохранить и войти',
      description:
        'Минимальная длина — 6 символов. Обязательно используйте одну заглавную букву, одну строчную букву и одну цифру',
      updatePasswordDescription:
        'Минимальная длина — 6 символов. Обязательно используйте одну заглавную букву, одну строчную букву и одну цифру. Новый пароль должен отличаться от старого',
      password: {
        label: 'Новый пароль',
        generatePasswordButton: 'Сгенерировать подходящий пароль',
      },
      invalidCode: 'Ссылка для смены пароля устарела, запросите восстановление пароля еще раз',
      successChanged: 'пароль успешно изменен',
      successLogin: 'Выполняется вход на сайт',
    },
    authFromSocial: {
      error: {
        title: 'Возникла ошибка',
        notEmailDescription: 'Нам не удалось получить от социальной сети адрес вашей электронной почты.',
        description: 'Ошибка сервера. Пока авторизоваться не получится. Попробуйте еще раз через несколько минут.',
        firstPartText: 'Чтобы закончить регистрацию, пожалуйста,',
        linkText: ' заполните форму ',
        lastPartText: 'на нашем сайте.',
      },
    },
    registration: {
      form: {
        title: 'Создание нового аккаунта',
      },
    },
    validatePassword: {
      title: 'Подтвердите вход в аккаунт',
      label: 'Ваш пароль',
      submitButton: 'Войти',
      footer: {
        firstPart: 'Нажимая на кнопку вы принимаете ',
        secondPart: 'условия пользовательского соглашения',
        thirdPart: ' и даете ',
        fourthPart: 'согласие на обработку персональных данных',
        fifthPart: ' и ',
        sixthPart: 'согласие на получение рекламных рассылок',
      },
    },
    shortForm: {
      form: {
        title: {
          phone: 'Укажите номер вашего телефона',
          staff: 'Укажите размер вашей компании',
          taxation: 'Укажите вашу систему налогобложения',
          position: 'Укажите вашу должность',
          organization: 'Укажите название вашей компании',
          postAndPhone: 'Два простых шага, чтобы получить профессиональную информацию бесплатно',
          birthDate: 'Укажите дату рождения',
          branch: 'Укажите ваш вид деятельности',
          educationDirection: 'Измените ваши данные',
        },
        submit: {
          finishRegistration: 'Завершить регистрацию',
          saveChanges: 'Сохранить изменения',
        },
        postAndFormShortuserAgreements: {
          firstText: 'Нажимая на кнопку "Завершить регистрацию", вы принимаете условия',
          conditionalTitle: 'пользовательского соглашения',
          secondText: 'и даете',
          consentToProcessing: 'согласие на обработку персональных данных',
          thirdText: 'и',
          consentToGetting: 'согласие на получение рекламных рассылок.',
          firstTextUz: 'Нажимая на кнопку "Завершить регистрацию", вы принимаете условия',
          conditionalTitleUz: 'пользовательского соглашения',
          secondTextUz: '.',
        },
        userAgreements: {
          text: 'Сохраняя данные, вы принимаете',
          link: 'пользовательское соглашение',
        },
      },
    },
    formComponents: {
      authorization: {
        buttonText: 'Войти',
      },
      header: {
        logoLink: 'https://action.group/',
      },
      form: {
        firstName: {
          name: 'Имя',
          validation: {
            required: 'Обязательно напишите имя',
            allowedSymbols: 'Можно использовать кириллицу и дефис',
            allowedUZSymbols: 'Можно использовать кириллицу, латиницу и дефис',
            minLength: `Обязательно напишите имя. Минимальная длина - ${NAME_MIN_LENGTH} символа`,
            maxLength: `Имя должно содержать не больше ${NAME_MAX_LENGTH} символов`,
          },
        },
        middleName: {
          name: 'Отчество',
          validation: {
            required: 'Обязательно напишите отчество',
            allowedSymbols: 'Можно использовать кириллицу и дефис',
            allowedUZSymbols: 'Можно использовать кириллицу, латиницу и дефис',
            minLength: `Обязательно напишите отчество. Минимальная длина - ${NAME_MIN_LENGTH} символа`,
            maxLength: `Отчество должно содержать не больше ${NAME_MAX_LENGTH} символов`,
          },
        },
        lastName: {
          name: 'Фамилия',
          validation: {
            required: 'Обязательно напишите фамилию',
            allowedSymbols: 'Можно использовать кириллицу и дефис',
            allowedUZSymbols: 'Можно использовать кириллицу, латиницу и дефис',
            minLength: `Обязательно напишите фамилию. Минимальная длина - ${NAME_MIN_LENGTH} символа`,
            maxLength: `Фамилия должна содержать не больше ${NAME_MAX_LENGTH} символов`,
          },
        },
        email: {
          name: 'Почта',
          description: 'вышлем ссылку для подтверждения регистрации',
          validation: {
            required: 'Без почты мы не сможем вас зарегистрировать',
            emailFormat: 'Неправильный формат почты. Пример: name@domain.ru',
            emailTemp: 'Регистрация с одноразовой почтой запрещена',
            maxLength: 'Неизвестная почта',
            alreadyExists: {
              text: 'Эта почта уже зарегистрирована.',
              linkToLogon: 'Войдите на сайт',
              concatenationText: 'или',
              linkToRestorePassword: 'восстановите пароль',
            },
          },
        },
        password: {
          name: 'Пароль',
          placeholder: 'Придумайте пароль',
          validation: {
            required: 'Придумайте пароль. Минимальная длина — 6 символов',
            requiredSymbols:
              'Минимальная длина — 6 символов. Обязательно используйте одну заглавную букву, одну строчную букву и одну цифру',
            allowedSymbols: 'Можно использовать латинские буквы, цифры и знаки .@-. Без пробелов. Минимум 6 символов',
            minLength: 'Минимальная длина — 6 символов',
            maxLength: `Пароль должен содержать не больше ${PASSWORD_MAX_LENGTH} символов`,
          },
        },
        phone: {
          name: 'Телефон',
          description: 'нужен, если забудете пароль',
          confirmed: 'подтвержден',
          validation: {
            required: 'Обязательно напишите телефон. Пример: +7 987 123 4567',
            phoneFormat: 'Неправильный формат телефона. Пример: +7 987 123 4567',
            requiredUz: 'Обязательно напишите телефон. Пример: +998 99 888 7766',
            phoneFormatUz: 'Неправильный формат телефона. Пример: +998 99 888 7766',
            alreadyExists: {
              text: 'Этот номер уже зарегистрирован.',
            },
          },
        },
        sendCode: {
          verifyWithCode: 'Подтвердить через код',
          getCodeAgain: 'Запросить код повторно:',
          getCodeAgainByCallAndSms: 'Запросить код повторно звонком или смс:',
          button: {
            smsText: 'Отправить СМС',
            codeCall: 'Получить звонок с кодом',
            divider: 'или',
            callText: 'Позвонить повторно',
            timeoutText: 'Отправить повторно через',
          },
          input: {
            callCodeLabel: 'Введите 4 цифры кода голосового сообщения',
            smsCodeLabel: 'Код из СМС',
            placeholder: 'Подтвердить через код СМС',
            callNumberLabel: 'Введите последние 4 цифры входящего номера',
            validation: {
              requiredCallCode: 'Введите 4 цифры кода голосового сообщения',
              requiredCallNumber: 'Поле обязательно для заполнения',
              requiredSmsCode: 'Введите код из 5 символов',
              incorrectSmsCode: 'Вы ввели неправильный код',
              codeIsNotAvailable: 'Срок действия кода подтверждения истек. Пожалуйста, запросите код повторно',
              incorrectCallCode: 'Вы ввели неверный код',
            },
          },
        },
        position: {
          placeholder: 'Впишите и выберите должность',
          name: 'Должность',
          validation: {
            required: 'Напишите Вашу должность. Минимальная длина - 3 символа',
            min: 'Минимальная длина - 3 символа',
          },
        },
        birthDate: {
          placeholder: 'Укажите дату рождения',
          name: 'Дата рождения',
          validation: {
            required: 'Необходимо заполнить дату рождения',
            incorrect: 'Дата имеет неверное значение',
          },
        },
        branch: {
          placeholder: 'Впишите и выберите ваш вид деятельности',
          name: 'Вид деятельности',
          validation: {
            incorrect: 'Напишите Ваш вид деятельности. Минимальная длина - 3 символа',
          },
        },
        socialField: {
          name: 'Зарегистрироваться с помощью соцсетей',
        },
        submitButton: {
          name: 'Зарегистрироваться',
          confirmation: {
            firstText: 'Нажимая на кнопку "Зарегистрироваться", вы принимаете условия',
            firstShortFormText: 'Нажимая на кнопку вы принимаете',
            conditionalTitle: 'пользовательского соглашения.',
            personalDataPolicy: 'политики обработки персональных данных',
            secondText: 'и даете',
            consentToProcessing: 'согласие на обработку персональных данных',
            thirdText: 'и',
            consentToGetting: 'согласие на получение рекламных рассылок',
            universityConsentToProcessing: 'согласие на обработку',
            transferToThirdParties: 'передачу третьим лицам персональных данных',
            unsubscribe: 'Не получать рекламные рассылки',
          },
        },
        logonButton: {
          name: 'Войти',
          href: '/Logon',
        },
        doYouHaveAccount: {
          name: 'Уже есть аккаунт?',
        },
        postStudent: {
          name: 'Студент или преподаватель',
          placeholder: 'выберите свое направление',
          validation: {
            required: 'Выберите студент или преподаватель',
          },
        },
        postStudentOrTeacher: {
          name: 'Студент / Преподаватель направления',
          placeholder: 'Выберите из списка',
          validation: {
            required: 'Пример: Студент направления Бухгалтерия',
          },
        },
        institute: {
          name: 'Название учебного заведения',
          placeholder: 'Выберите название учебного заведения',
          validation: {
            required: 'Выберите название учебного заведения',
          },
        },
        specialty: {
          name: 'Специальность',
          placeholder: 'Выберите свою специальность',
          validation: {
            required: 'Выберите специальность',
          },
        },
        degree: {
          name: 'Курс',
          placeholder: 'Выберите свой курс',
          validation: {
            required: 'Выберите курс',
          },
        },
        region: {
          name: 'Регион',
          placeholder: 'Выберите регион',
          validation: {
            required: 'Выберите регион',
          },
        },
        organization: {
          name: 'Компания',
          validation: {
            required: 'Обязательно напишите название компании',
            minLength: 'Минимальная длина — 3 символа',
          },
        },
        university: {
          name: 'Образовательное учреждение',
          placeholder: 'выберите образовательное учреждение',
          validation: {
            required: 'Образовательное учреждение обязательно',
            minLength: `Минимум ${UNIVERSITY_MIN_LENGTH} буквы`,
          },
        },
        staff: {
          validation: {
            required: 'Необходимо указать размер вашей компании',
          },
        },
        taxation: {
          validation: {
            required: 'Выберите форму налогобложения из представленного списка',
          },
        },
        serverErrors: {
          'Sms code is incorrect': 'Вы ввели неправильный код',
        },
        serverErrorMessage: {
          header: 'Ошибка сервера',
          description: 'Попробуйте еще раз через несколько минут',
        },
      },
      successForm: {
        title: 'Всё получилось, теперь вы с нами!',
        titleError: 'Произошла ошибка',
        description: 'Осталось подтвердить почту. Мы отправили ссылку на адрес',
        descriptionError: 'Не удалось отправить ссылку на адрес',
        description2: 'Если вы не видите письма, посмотрите в рассылках или спаме.',
        description2Error:
          'Отправьте запрос повторно с текущей страницы. Или в любое время, со страницы входа в продукты.',
        sendAgain: 'Отправить повторно',
        sendAgainTimer: 'Отправить повторно через',
        login: 'Перейти ко входу в продукты',
      },
    },
    outdatedLink: {
      button: {
        href: '/Logon',
      },
    },
  },
}
